<template>
    <rkm-overlay>
        <rkm-layout-body title="C5 - Cuidado da pessoa com hipertensão">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-cuidado-pessoa-hipertensao/List'

export default {
    components: { List },
}
</script>